require('./loansError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require("react-router-dom");

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

class LoansError extends React.Component {
  constructor(props) {
    super(props);
    this.onClickMainButton = this.onClickMainButton.bind(this);
  }

  onClickMainButton() {
    const url = '/myprofile/global';
 
    this.props.history.push(url);
  }



  render() {

    const mainButtonDefault = {
      label: (
        <FormattedText
          format="uppercase"
          value="loanError-backButtonLabel"
        />
      ),
      url: '/myprofile/loans-mortgages',
    }

    const errorMessage = formatText('hireCardViaT-errorTitleGeneric');
    return (
      <div className="loans-error">
        <div className="loans-error__highlight">
          <i className="loans-error__icon" >
          </i>
          <div className="loans-error__messages">
            <OKBoxTitle value={errorMessage} />
          </div>
        </div>
        <div className="loans-error__content">
          <FormattedText
            value="loanError-errorTextDescription"
            className="loans-error__message"
          />
        </div>
        <div className="loans-error__footer">
          <div className="loans-error__separator" />
          <div className="loans-error__foot-buttons">
            <div className="loans-error__main-button">
              <OKButton
                id="lnk_loansError_mainButton"
                modifier="link-complementary"
                onClick={ this.onClickMainButton}
              >
              {mainButtonDefault.label}
            </OKButton>
          </div>
        </div>
      </div>
      </div >
    );
  }
}




LoansError.propTypes = {
  hideBlockedAccountError: PropTypes.func,
  mainButton: PropTypes.object,
  cancelButton: PropTypes.object,
  history: PropTypes.object.isRequired,
};

LoansError.defaultProps = {
  hideBlockedAccountError: () => { },
}

module.exports = withRouter(LoansError);
